import React,{useState,useEffect} from "react";
import "./TermsAndConditions.css";
import { Link } from "react-router-dom";
const CustomerGrievancePolicy = () => {
  const [isVisible, setIsVisible] = useState(false);
  
    // Show button only after scrolling 200px
    useEffect(() => {
      const toggleVisibility = () => {
        if (window.scrollY > 200) {
          setIsVisible(true);
        } else {
          setIsVisible(false);
        }
      };
  
      window.addEventListener("scroll", toggleVisibility);
      return () => window.removeEventListener("scroll", toggleVisibility);
    }, []);
  
    const scrollToTop = () => {
      window.scrollTo({ top: 0, behavior: "smooth" });
    };
  return (
    <div className="page-body">
    <div className="terms-container">
     {/* <div className="d-flex justify-content-between align-items-center flex-wrap mb-3">
          <h5 className="page-title mt-3"><strong>Customer Grievance Policy</strong></h5>
          <div className="breadcrumb m-0 text-end">
           <Link to="/compliance-center">Compliance Center</Link>  &nbsp;&gt;&nbsp;
            <strong>Customer Grievance Policy</strong>
          </div>
        </div> */}
 <div className="d-flex justify-content-between align-items-center flex-wrap mb-3">
  <h5 className="page-title mt-3">
    <p style={{fontWeight:"600"}}>Customer Grievance Policy</p>
  </h5>
<div className="breadcrumb m-0 text-end">
  <Link to="/" className="breadcrumb-link">
    Home
  </Link>
  &nbsp;&gt;&nbsp;
  <Link to="/compliance-center" className="breadcrumb-link">
    Compliance Center
  </Link>
  &nbsp;&gt;&nbsp;
  <span className="breadcrumb-current">Customer Grievance Policy</span>
</div>

</div>
    

  <p>As a Payment Operator, resolving customer grievances suitably and efficiently is paramount for TA (Transaction Analysts) and the object of this policy is to minimize instances of customer complaints through proper review mechanism and service delivery and to ensure prompt redressal of various types of customer complaints.<br/>
We as Transaction Analysts (TA) understand the importance of customer service which should be prompt and complete in all respects. To achieve this we have taken adequate measures which allow our customers to reach us in multiple ways and we ensure that all customer grievances are recorded and reference number given to the customer for future follow-ups. The internal process in the company takes care of addressing the client request with proper feedback and closing the issue only once confirmed by the client. Internal escalation mechanism exists to automatically forward the issue to next levels based on their importance and time taken to resolve. We ensure the below as part of our internal processes.</p>
<ol>
<li>Customers are to be treated fairly at all times.</li>
<li>Customers are fully informed of avenues to escalate their complaints/ grievances within the organization and their rights to alternative&nbsp;remedy,&nbsp;if they are not fully satisfied with the response to their complaints.</li>
<li>Complaints made by customers are dealt with promptly and with compassion.</li>
<li>We will treat all complaints efficiently and fairly and the interest of the customer will be presented in good faith and without prejudice.</li>
<li>We understand the frustration our customers feel when something goes wrong. We will look to you to provide all relevant information; including identifying the issue and the solution you are seeking. In turn, we will do our best to resolve your issue quickly, professionally, efficiently and fairly and keep you informed of the progress.</li>
</ol>
<h5 class="vc_custom_heading"><strong>HOW TO REACH US AND REGISTER COMPLAINTS</strong></h5>
<p>Our customers can contact our dedicated Call center/Customer Service Delivery Department (CSD) for any customer queries and to register grievances if any.<br/>
A customer has the right to register his/her complaint if he/she is not satisfied with any of the following:</p>
<ul>
<li>Any Service provided by TA.</li>
<li>System errors – Causing delay in service.</li>
<li>Unhappy with the quality of Customer Service provided when dealing with staff/CSD</li>
<li>Or any other grievances</li>
</ul>
<p>The Customer can lodge a complaint in the following three ways:</p>
<ul>
<li>A customer can contact our Support Team :
<ul>
<li>+91 – 9916788339, 24X7 and register their complaints</li>
</ul>
</li>
<li>By writing an email to&nbsp;<a href="mailto:grievances@icashcard.in">– care@transactionanalysts.com</a></li>
<li>By visiting the company’s Website:-
<ul>
<li>https://transactionanalysts.com/contact-us and lodging your complaint.</li>
</ul>
</li>
</ul>
<h5 class="vc_custom_heading"><strong>Acknowledgment OF GRIEVANCES</strong></h5>
<ul>
<li>TA’s Grievance Redressal Mechanism (GRM) is simpler without customers facing the hassles of proving identity, account details, etc. Each complaint is assigned and identified by a unique complaint reference number.</li>
<li>Any grievance received through any of the above channels will be routed to our dedicated customer complaint service desk who will immediately record your feedback/grievance.</li>
<li>If the grievance is received through an email or our website, such complaints shall be acknowledged by an immediate system generated response or via individual emails to the extent possible.</li>
<li>The follow-up action taken in respect of such complaints shall be advised to customers by e-mail. The Customer Service Representative (CSR) will also attempt to contact the customer if additional information is required for effective resolution. Our CSR will also advise the defined SLA and keep the customer informed.</li>
<li>Moreover, the customers can track the status of the complaints on the basis of the unique complaint reference number from any location. Standardized rules and regulations with&nbsp;unified&nbsp;service level agreement (SLA) are formed and are applicable to all disputes raised.</li>
<li>If the complaint is not resolved within the given time (SLA) or if he/she is not satisfied with the resolution provided, they can refer to the escalation matrix mentioned below and escalate the issue to the higher authority.</li>
</ul>
<h5  class="vc_custom_heading"><strong>SLA</strong></h5>
<figure class="wp-block-table">
<table class="has-fixed-layout">
<thead>
<tr>
<th>Resolution</th>
<th>SLA</th>
</tr>
</thead>
<tbody>
<tr>
<td data-label="Resolution">Status Unknown Transaction for IMPS</td>
<td data-label="SLA">7 Business Days</td>
</tr>
<tr>
<td data-label="Resolution">Successful transaction but Beneficiary not credited</td>
<td data-label="SLA">Beneficiary not credited 7 Business Days</td>
</tr>
<tr>
<td data-label="Resolution">Mobile recharge Transaction &amp; DTH Payments</td>
<td data-label="SLA">3 Business Days</td>
</tr>
<tr>
<td data-label="Resolution">Bill payment Related Issues</td>
<td data-label="SLA">3 Business Days</td>
</tr>
<tr>
<td data-label="Resolution">Wallet related issues</td>
<td data-label="SLA">2 Business Days</td>
</tr>
<tr>
<td data-label="Resolution">C3 (CUG) related issues</td>
<td data-label="SLA">2 Business Days</td>
</tr>
<tr>
<td data-label="Resolution">AADHAAR related issues</td>
<td data-label="SLA">2 Business Days</td>
</tr>
</tbody>
</table>
</figure>
<h5  class="vc_custom_heading"><strong>Customer Grievance Escalation Matrix:</strong></h5>
<p>At Transaction Analysts, we treat every customer feedback (Compliments and Complaints) with utmost priority and we seek at ways to provide customer satisfaction. We value every feedback as it provides us actionable insights to improve our business, products and service and overall customer experience. We, therefore encourage our customers to provide their feedback and they can record their grievances / provide their feedback in writing or verbally. The customer can approach TA to register a complaint through any of our service touch points given hereunder and we assure the highest resolution priority to escalated cases.<br/>
We have developed an escalation matrix, to handle our customer grievances effectively and efficiently. Instances where a customer does not receive a response within the specified time frame or if the customer is dissatisfied with the response received at the first level, the customer can escalate the complaint to the next level as indicated below. Highest resolution priority is given to escalation cases.</p>

<h3  class="vc_custom_heading"><strong>Level 2</strong></h3>
<p>Customer can address the grievance to the below address or an email for<br/>
escalations:-<br/>
<strong>Mr. P. Kiran Kumar</strong><br/>
Client – Customer Relations &amp;amp; Quality Assurance<br/>
Transaction Analysts (India) Private Limited<br/>
#4 ,&nbsp;Sathyam&nbsp;Arcade 1st&nbsp;Floor&nbsp;, 1st Phase<br/>
BTM Layout ,&nbsp;2nd Stage<br/>
Bangalore – 560076 , India.<br/>
Email:&nbsp;<a href="mailto:kirankumar.p@taipl.in">kirankumar.p@taipl.in</a></p>

<h3  class="vc_custom_heading"><strong>Level 3</strong></h3>

<p>If customer is still not satisfied with the resolution received, or if customer do not hear from us within specified time limit after following the above mentioned escalation steps, he/she can further escalate the issue to:<br/>
<strong>Sreenivasulu M</strong><br/>
Director – Projects<br/>
Transaction Analysts (India) Private Limited<br/>
#4 ,&nbsp;Sathyam&nbsp;Arcade 1st&nbsp;Floor&nbsp;, 1 st Phase<br/>
BTM Layout ,&nbsp;2nd Stage<br/>
Bangalore – 560076 , India.<br/>
Email: <a href="mailto:sreenivasulu.m@transactionanalysts.com">sreenivasulu.m@transactionanalysts.com</a></p>






<p>Upon receiving the complaint, we will acknowledge within 2 business days.Further response to the escalated issue will be sent within 7 business days post acknowledgement.</p>





       {/* Add Button (aligned to left) */}
 {isVisible && (
          <button className="scroll-to-top" onClick={scrollToTop}>
            <i className="bi bi-chevron-up"></i>
          </button>
        )}
  

  </div>
  </div>
  );
};

export default CustomerGrievancePolicy;
